"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAPIInstances = exports.deleteAPIInstance = exports.createEventedAPIInstance = exports.createAPIInstance = void 0;
exports.getAPIInstancesForRequestAPIAccessModal = getAPIInstancesForRequestAPIAccessModal;
exports.updateEventedAPIInstance = exports.updateAPIInstance = exports.loadAPIInstances = void 0;
exports.validateAPIInstanceVisibilityChange = validateAPIInstanceVisibilityChange;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _actionify = _interopRequireDefault(require("@mulesoft/exchange-ui-portals-store/lib/utils/actionify"));
var actions = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function setAPIInstanceIsLoading(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    isLoading = _ref.isLoading,
    instanceId = _ref.instanceId;
  return {
    type: actions.SET_API_INSTANCE_IS_LOADING,
    groupId: groupId,
    assetId: assetId,
    isLoading: isLoading,
    instanceId: instanceId
  };
}
var createAPIInstance = exports.createAPIInstance = (0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
  return service.createExternalInstance;
}, actions.CREATE_EXTERNAL_API_INSTANCE);
var createEventedAPIInstance = exports.createEventedAPIInstance = (0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
  return service.createExternalEventedAPIInstance;
}, actions.CREATE_EXTERNAL_API_INSTANCE);
var updateAPIInstance = exports.updateAPIInstance = (0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
  return service.update;
}, actions.UPDATE_API_INSTANCE);
var updateEventedAPIInstance = exports.updateEventedAPIInstance = (0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
  return service.updateEventedAPIInstance;
}, actions.UPDATE_API_INSTANCE);
var deleteAPIInstance = exports.deleteAPIInstance = (0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
  return function (_ref2) {
    var context = _ref2.context,
      groupId = _ref2.groupId,
      assetId = _ref2.assetId,
      versionGroup = _ref2.versionGroup,
      instance = _ref2.instance;
    return service.removeExternalInstance({
      context: context,
      groupId: groupId,
      assetId: assetId,
      versionGroup: versionGroup,
      apiId: instance.id
    });
  };
}, actions.DELETE_API_INSTANCE);
var loadAPIInstances = exports.loadAPIInstances = function loadAPIInstances(asset) {
  return {
    type: actions.FETCH_API_INSTANCE_LIST.SUCCESS,
    params: {
      groupId: asset.groupId,
      assetId: asset.assetId,
      minorVersion: asset.minorVersion,
      versionGroup: asset.versionGroup
    },
    result: asset.instances
  };
};
var getAPIInstances = exports.getAPIInstances = (0, _actionify.default)(_exchangeApiClient.InstanceService, function (service) {
  return function (params) {
    return service.list(params);
  };
}, actions.FETCH_API_INSTANCE_LIST, {
  once: true,
  requestCompare: function requestCompare(params, oldParams) {
    return params.groupId === oldParams.groupId && params.assetId === oldParams.assetId && params.versionGroup === oldParams.versionGroup;
  }
});
function getAPIInstancesForRequestAPIAccessModal() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return function (dispatch) {
    return dispatch(getAPIInstances.apply(void 0, params)).catch(function () {});
  };
}
function validateAPIInstanceVisibilityChange(_ref3) {
  var instanceId = _ref3.instanceId,
    groupId = _ref3.groupId,
    assetId = _ref3.assetId,
    versionGroup = _ref3.versionGroup;
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState, _ref4) {
      var config, state, context, relatedAPIGroups, apiInstanceService;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _ref4.config;
            state = getState();
            context = _exchangeUiPortalsStore.selectors.selectContext(state);
            dispatch(setAPIInstanceIsLoading({
              groupId: groupId,
              assetId: assetId,
              instanceId: instanceId,
              isLoading: true
            }));
            apiInstanceService = new _exchangeApiClient.InstanceService(config);
            _context.prev = 5;
            _context.next = 8;
            return apiInstanceService.listRelatedAPIGroupInstances({
              context: context,
              groupId: groupId,
              assetId: assetId,
              versionGroup: versionGroup,
              apiId: instanceId
            });
          case 8:
            relatedAPIGroups = _context.sent;
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            relatedAPIGroups = [];
          case 14:
            dispatch(setAPIInstanceIsLoading({
              groupId: groupId,
              assetId: assetId,
              instanceId: instanceId,
              isLoading: false
            }));
            if (!(relatedAPIGroups.length === 0 || relatedAPIGroups.every(function (relatedAPIGroup) {
              return !relatedAPIGroup.isPublic;
            }))) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", false);
          case 17:
            return _context.abrupt("return", true);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 11]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();
}
//# sourceMappingURL=actions.js.map